import * as React from 'react';

import { ExperimentalOverlay } from '../../components/debug/ExperimentalOverlay';
import { bottomSheetStore } from '../../stores/BottomSheetStore';
import { layoutInformation } from '../../submodules/xbox/utils/Layout';

import { Valid } from './bottomInfo/Valid';
import { Watermark } from './bottomInfo/Watermark';
import { useGetViewerComponent } from './getViewerComponent';

import { makeStyles } from '@egr/xbox/utils/tss-react';

const useStyles = makeStyles({ name: 'ViewerContainer' })((theme) => ({
    root: {
        width: '100%',
        height: '100%',
        backgroundColor: 'white',
    },
}));

export const ViewerContainer: React.FC = () => {
    const { classes } = useStyles();

    const viewer = useGetViewerComponent();
    const { bottomSpacing } = bottomSheetStore.useState(['bottomSpacing']);
    const { smallLayout } = layoutInformation.useState(['smallLayout']);
    return (
        <div
            id="viewer-container"
            className={classes.root}
            style={{
                transform: smallLayout && bottomSpacing ? 'translateY(-25%)' : 'none',
                transition: 'transform 0.2s ease-out',
                flex: 1,
            }}
        >
            <React.Suspense>{viewer}</React.Suspense>
            <Watermark />
            <Valid />
            <ExperimentalOverlay />
        </div>
    );
};
